import axios from "axios";
const baseURL = process.env.REACT_APP_AXIOS_URL;
const axiosInstance = axios.create({
  baseURL,
});
export default axiosInstance;
